import type { Dayjs } from 'dayjs';
import { FC } from 'react';
import { TimePicker } from 'antd';

import Text from '../Text';
import { RED, STROKE, TEXT } from '../../Helpers/colors';
import { InputBackgroundType, backgroundColors, disabledBackgroundColors } from '../Input';

interface TimePickerProperties {
	backgroundType?: InputBackgroundType;
	className?: string;
	description?: string;
	disabled?: boolean;
	error?: boolean;
	errorMessage?: string;
	label: string;
	onChange: (date: Dayjs | null) => void;
	value: Dayjs | null;
}

const CustomTime: FC<TimePickerProperties> = ({
	label,
	value,
	onChange = () => null,
	className = '',
	error = false,
	disabled = false,
	errorMessage = '',
	description = '',
	backgroundType = 'primary',
}) => (
	<div className={className}>
		<Text
			className={`inputLabel ${label ? 'active' : ''}`}
			title={label}
			type="psm"
			fontWeight="medium"
			color={disabled ? TEXT.QUATERNARY : TEXT.PRIMARY}
		/>
		<TimePicker
			value={value}
			format="hh:mm A"
			placeholder="09:00 AM"
			onChange={onChange}
			size="large"
			inputReadOnly={false}
			allowClear={false}
			needConfirm={false}
			disabled={disabled}
			getPopupContainer={(triggerNode) => triggerNode}
			showNow={false}
			use12Hours
			style={{
				minWidth: 'max-content',
				width: '100%',
				border: `1px solid ${error ? RED.BASE : STROKE.SECONDARY}`,
				backgroundColor: disabled ? disabledBackgroundColors[backgroundType] : backgroundColors[backgroundType],
				color: TEXT.PRIMARY,
				borderRadius: '9px',
			}}
		/>
		<Text className={`error ${error ? 'active' : ''}`} title={errorMessage} fontWeight="medium" color={RED.BASE} />
		<Text
			className={`inputDescription ${!error && Boolean(description) ? 'active' : ''}`}
			title={description}
			fontWeight="medium"
		/>
	</div>
);

export default CustomTime;
